/**
 * Created by swandelow on 9/13/16.
 */
angular.module('CarsSaraBo').directive('doubleDate', function () {
    return {
        scope: {
            ngModel: '=ngModel',
            name: '@',
            fromPlaceholder: '@',
            toPlaceholder: '@',
            isRequired: '=',
            errorFields: '=',
            editable: '=editable'
        },

        link: function (scope) {

            function isUndefined(field) {
                return field == undefined || field == '';
            }

            scope.$watch("errorFields", function () {
                console.log("(doubleDate)", scope.errorFields);
            });

            scope.$watch('ngModel.from', function () {
                var fromName = scope.name + '-from';
                updateValidation(fromName);
                updateValidation(scope.name);
                if(scope.ngModel && isUndefined(scope.ngModel.from) && isUndefined(scope.ngModel.to)) {
                    delete scope.ngModel;
                }
            });

            scope.$watch('ngModel.to', function () {
                var toName = scope.name + '-to';
                updateValidation(toName);
                updateValidation(scope.name);
                if(scope.ngModel && isUndefined(scope.ngModel.from) && isUndefined(scope.ngModel.to)) {
                    delete scope.ngModel;
                }
            });

            scope.$watch('isRequired', function () {
                if(!scope.isRequired){
                    delete scope.ngModel;
                }
            });

            function updateValidation(field) {
                if (scope.errorFields != undefined && scope.errorFields[field]) {
                    scope.errorFields[field] = null;
                }
            }

        },

        templateUrl: 'assets/commons/doubledate.html'
    };
});


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/double_date_directive.js
// module id = 875
// module chunks = 3